// components/MenuItems.jsx
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/menuitems.css";

const menuItems = [
    { label: "Assessments", path: "/assessments" },
    { label: "Questions", path: "/questions-review" },
    { label: "Chapters", path: "/chapters" },
    { label: "Concepts", path: "/concepts" }
    // { label: "Learning Resources", path: "/resources" },
    // { label: "Students", path: "/students" },
    // { label: "Evaluations", path: "/evaluations" },
    // { label: "Classes", path: "/classes" },
    // { label: "Earnings", path: "/earnings" },
];

const MenuItems = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <nav className="header-nav">
            {menuItems.map((item) => (
                <span
                    key={item.path}
                    className={`nav-link ${location.pathname === item.path ? "active" : ""}`}
                    onClick={() => navigate(item.path)}
                >
                    {item.label}
                </span>
            ))}
        </nav>
    );
};

export default MenuItems;
